import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { DonationRoute, Route } from '@caritas/ui';
import React from 'react';

import { useDonationPagePreviewQuery } from '../../../generated/queries/preview';
import { mapDonationPage } from '../../fragments/DonationPage.mappers';
import { useTranslations } from '../../fragments/Translations.mappers';
import { Page } from '../../utils/Page';
import { usePreviewParameters } from '../../utils/preview';

export default function DonationPreview() {
  const params = usePreviewParameters();
  const pageContext: SilverbackPageContext = {
    typeName: 'Donation',
    id: params.nid,
    remoteId: `${params.nid}:${params.lang}`,
    locale: params.lang,
    localizations: [],
  };

  const { data } = useDonationPagePreviewQuery({
    id: params.nid,
    rid: params.rid,
  });

  const content = data?.loadDonationRevision?.translations.filter(
    (trans) => trans.langcode === params.lang,
  )[0];

  const translations = useTranslations(pageContext);

  return content ? (
    <Page pageContext={pageContext}>
      <Route
        definition={DonationRoute}
        input={mapDonationPage(content, pageContext)}
        intl={translations}
      />
    </Page>
  ) : (
    <p>Loading preview</p>
  );
}
